// 简易封装一些消息框，方便使用
import { ElNotification, ElMessage, ElMessageBox } from "element-plus";
import { h } from "vue";
import { useRouter } from "vue-router";
import router from "@/router/index";
import { ElButton } from "element-plus";
export const confirmBox = (
  content = "是否确认删除",
  title = "提示",
  type = "warning",
  confirmButtonText = "确定",
  cancelButtonText = "取消"
) => {
  return ElMessageBox.confirm(content, title, {
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    type: type,
    dangerouslyUseHTMLString: true, // 添加这个属性以允许使用 HTML
    distinguishCancelAndClose: true,
  });
};

export const confirmDeleteBox = (
  content = "是否确认删除",
  title = "提示",

  type = "warning",
  confirmButtonText = "确认",
  cancelButtonText = "取消"
) => {
  return ElMessageBox.confirm(content, title, {
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    type: type,
  });
};
export const confirmUpdateRoleBox = (
  content = "是否确认升级",
  title = "提示",

  type = "warning",
  confirmButtonText = "确认",
  cancelButtonText = "取消"
) => {
  const goPrice = () => {
    // const router = useRouter();

    const resolved = router.resolve({
      name: "Pricing",
    });
    const url = resolved.href;

    window.open(url, "_blank");
  };

  return ElMessageBox.confirm(
    h("p", null, [
      h("div", null, content),
      h(
        ElButton,
        { onClick: goPrice, link: true, type: "primary" },
        "升级版本，享更多权益"
      ),
    ]),
    title,
    {
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      type: type,
    }
  );
};
